import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from 'contexts/AuthContext';
import { UIProvider } from 'contexts/UIContext';
import { SubscriptionProvider } from 'contexts/SubscriptionContext';
import { ProtectedRoute } from 'components/ProtectedRoute';
import { SubscriptionGuard } from 'components/SubscriptionGuard';
import { SignupDataProcessor } from 'components/SignupDataProcessor';
import { Toast } from 'components/ui/Toast';
import { Login } from 'pages/Login';
import { Signup } from 'pages/Signup';
import { ResetPassword } from 'pages/ResetPassword';
import { UpdatePassword } from 'pages/ResetPassword/UpdatePassword';
import { Dashboard } from 'pages/Dashboard';
import Agent from 'pages/Agent';
import { ContentLibrary } from 'pages/ContentLibrary';
import { BrandAssets } from 'pages/BrandAssets';
import Settings from 'pages/Settings';
import { Onboarding } from 'pages/Onboarding';
import { Paywall } from 'pages/Paywall';
import { PaymentStatus } from 'pages/PaymentStatus';
import Training from 'pages/Training';

function App() {
  return (
    <Router>
      <UIProvider>
        <AuthProvider>
          <SubscriptionProvider>
            <SubscriptionGuard>
              <SignupDataProcessor />
              <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-password/update" element={<UpdatePassword />} />

            {/* Onboarding - full screen */}
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute skipOnboardingCheck={true}>
                  <Onboarding />
                </ProtectedRoute>
              }
            />

            
            {/* Dashboard - layout with sidebar + nested routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            >
              {/* Index route - redirect to assistant */}
              <Route index element={<Navigate to="/dashboard/assistant" replace />} />

              {/* Nested routes */}
              <Route path="assistant" element={<Agent />} />
              <Route path="content-library" element={<ContentLibrary />} />
              <Route path="brand-assets" element={<BrandAssets />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            {/* Paywall - full screen */}
            <Route
              path="/paywall"
              element={
                <ProtectedRoute>
                  <Paywall />
                </ProtectedRoute>
              }
            />

            {/* Payment Status - full screen */}
            <Route
              path="/payment-status"
              element={
                <ProtectedRoute skipOnboardingCheck={true}>
                  <PaymentStatus />
                </ProtectedRoute>
              }
            />

            {/* Training - full screen */}
            <Route
              path="/training"
              element={
                <ProtectedRoute>
                  <Training />
                </ProtectedRoute>
              }
            />

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Routes>
              <Toast />
            </SubscriptionGuard>
          </SubscriptionProvider>
        </AuthProvider>
      </UIProvider>
    </Router>
  );
}

export default App;
